<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="eventSensorReadings-modal">
<!-- <div class="modal-content eventSensorReadings-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 style="color: rgb(10, 10, 10); text-transform: none;">Evaluated sensor conditions for '{{event.name}}'</h5>
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div class="modal-body">
    <div style="font-size: 15px; height: 35px; background-color: var(--kig-section-header-bg);">
      <label style="margin-top: 7px; margin-left: 10px;">Evaluation Window</label>
    </div>
    <div style="font-size: 15px;">
      <br>&nbsp;&nbsp;
      From: <b>{{event.evaluateStartTime}}</b>&nbsp;&nbsp;
      To: <b>{{event.evaluateEndTime}}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      Days Of Week: <b>{{event.evaluateDaysOfWeekUser}}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- Currently: <b>{{event.evaluateActiveState}}</b> -->
    </div>
    <br>
    <p-table [columns]="evaluateSensorEventResultsCols" [value]="conditionResults" >
      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData ; pTemplate="body">
        <tr>
          <td class="text-center">
            {{rowData.sensorGroup}}
          </td>
          <td class="text-center">
            {{rowData.condition}}
          </td>
          <td class="text-center">
            {{rowData.numericalValue}}
          </td>
          <td class="text-center">
            <!-- {{ rowData.booleanValue }} ({{rowData.errorCode}}) -->
            {{ rowData.booleanValue }}
          </td>
          <td class="text-center">
            <div *ngIf="!isLastConditionResult(rowData.id)">
              {{rowData.logicOperator | lowercase}}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <br>
    <p-table [value]="conditionResults" >
      <ng-template let-columns pTemplate="header">
        <tr>
          <th style="background-color: var(--kig-section-header-bg);">
            <div style="display: flex; align-items: center;">
              <label>Details</label>
              <span style="margin-left: 30px; font-size: 13px; font-weight: normal;">
                <input type="checkbox" id="showAllReadingsEvaluated" name="showAllReadingsEvaluated"
                       [(ngModel)]="showAllReadingsEvaluated" (ngModelChange)="saveDetailsViewOptions()" style="cursor: pointer;"/>
                <label for="showAllReadingsEvaluated" style="padding-left: 5px; padding-right: 25px; cursor: pointer;">Show All Readings Evaluated</label>
                <input type="checkbox" id="showReadingsMeetingCondition" name="showReadingsMeetingCondition"
                       [(ngModel)]="showReadingsMeetingCondition" (ngModelChange)="saveDetailsViewOptions()" style="cursor: pointer;"/>
                <label for="showReadingsMeetingCondition" style="padding-left: 5px; cursor: pointer;">Show Readings Meeting Condition</label>
              </span>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template let-rowData ; pTemplate="body">
        <tr *ngIf="hasDetails(rowData)">
          <td>
            <div style="white-space: pre-wrap;">{{getDetailsSummary(rowData)}} </div>
            <div *ngIf="showReadingsMeetingCondition && rowData.matchedReadingsDetails" style="white-space: pre-wrap;">{{rowData.matchedReadingsDetails}} </div>
            <div *ngIf="showAllReadingsEvaluated && rowData.allReadingsDetails" style="white-space: pre-wrap;">{{rowData.allReadingsDetails}} </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div >
      <br>
      <span>Currently: <b>{{event.evaluateActiveState}}</b></span>
      <span *ngIf="event.evaluateActiveState=='active' && taskResults.overallConditionResult" style="color: #64a70b; float: right">True</span>
      <span *ngIf="event.evaluateActiveState!='active' || !taskResults.overallConditionResult" style="color: #c8102e; float: right">False</span>
      <span style="float: right">Overall: &nbsp;</span>
      &nbsp;&nbsp;
      <br>
    </div>

  </div>
</div>
